package com.exura.features.userprofile.domain.model

import com.exura.features.newauth.domain.model.ProviderUserRole
import dev.gitlive.firebase.firestore.CollectionReference

abstract class ProviderProfile(
    firebaseDocId: String? = null,
    firebaseDocPrefix: CollectionReference? = null,
    providerRole: ProviderUserRole,
) : UserSettingsBase(
    firebaseDocId,
    firebaseDocPrefix,
    providerRole.authRole,
) {
    abstract val email: String
    abstract fun makeStamp(): Stamp
}
